"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseHandler = exports.Connection = void 0;
const websocket_1 = require("websocket");
var websocket_2 = require("websocket");
Object.defineProperty(exports, "Connection", { enumerable: true, get: function () { return websocket_2.w3cwebsocket; } });
const message_1 = require("../message");
class Executor {
    constructor(resolve, reject) {
        this.resolve = resolve;
        this.reject = reject;
    }
}
class BaseHandler {
    constructor(connection, id) {
        this.connection = connection;
        this.id = id;
        this.active = true;
        this.childs = new Map();
        this.executors = new Map();
    }
    cleanUp() {
        if (this.active) {
            this.active = false;
            for (const map of this.executors.values()) {
                for (const executor of map.values()) {
                    executor.reject(new Error("Handler destroyed"));
                }
            }
            for (const child of this.childs.values()) {
                child.cleanUp();
            }
            return true;
        }
        else {
            return false;
        }
    }
    attach(child) {
        this.childs.set(child.id, child);
        if (!this.active) {
            child.cleanUp();
        }
    }
    detach(id) {
        if (this.childs.has(id)) {
            const child = this.childs.get(id);
            this.childs.delete(id);
            if (child) {
                if (child.active) {
                    child.cleanUp();
                }
            }
        }
    }
    handleMessage(message) {
        const map = this.executors.get(message.type);
        if (map) {
            const executor = map.get(message.id);
            if (executor) {
                if (message.content.error) {
                    executor.reject(message.content.error);
                }
                else {
                    executor.resolve(message);
                }
            }
        }
        for (const child of this.childs.values()) {
            if (child.active) {
                child.handleMessage(message);
            }
        }
    }
    send(message) {
        if (this.connection.readyState === websocket_1.w3cwebsocket.OPEN) {
            this.connection.send(message.toString());
        }
    }
    async sendRequest(type, content) {
        return new Promise((resolve, reject) => {
            try {
                const message = new message_1.Message(type, content);
                this.send(message);
                let map = this.executors.get(message.type);
                if (!map) {
                    map = new Map();
                    this.executors.set(message.type, map);
                }
                map.set(message.id, new Executor(resolve, reject));
            }
            catch (e) {
                reject(e);
            }
        });
    }
    async sendResponse(request, content) {
        return new Promise((resolve, reject) => {
            try {
                const message = new message_1.Message(request.type, content, request.id);
                this.send(message);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    }
}
exports.BaseHandler = BaseHandler;
